var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Label } from 'recharts-v2';
import { buildDataForChart, renderActiveShape } from './ReportPieChartHelper';
export var ChartType;
(function (ChartType) {
    ChartType["FULL"] = "FULL";
    ChartType["HALF"] = "HALF";
})(ChartType || (ChartType = {}));
export var ReportPieChartConfig = {
    PIE_CX: '50%',
    PIE_CY: '50%',
    PIE_START_ANGLE: 180,
    PIE_END_ANGLE: 0,
    PIE_INNER_R: '65%',
    PIE_OUTER_R: '100%',
    DATA_POINT_INNER_R: 3.5,
    DATA_POINT_OUTER_R: 9,
    DATA_POINT_STROKE_WIDTH: 3,
    DEFAULT_ANIMATION_BEGIN: 400,
    ANIMATION_DURATION: 1200,
    CORNER_RADIUS: 0
};
var getChartConfig = function (type) {
    if (type === ChartType.FULL) {
        return __assign(__assign({}, ReportPieChartConfig), { PIE_START_ANGLE: 90, PIE_END_ANGLE: -360 });
    }
    return ReportPieChartConfig;
};
var ReportPieChart = function (_a) {
    var type = _a.type, value = _a.value, total = _a.total, fillColorClass = _a.fillColorClass, hideIndicator = _a.hideIndicator, gapSize = _a.gapSize, multiplePieces = _a.multiplePieces, name = _a.name, centerText = _a.centerText, customChartConfig = _a.customChartConfig, cornerRadius = _a.cornerRadius;
    var chartConfig = customChartConfig || getChartConfig(type);
    var paddingAngle = gapSize || 0;
    var mergedCornerRadius = cornerRadius || chartConfig.CORNER_RADIUS;
    var _b = buildDataForChart(value, total, multiplePieces), data = _b.data, activeIndex = _b.activeIndex;
    return (<ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie data={data} dataKey="value" activeIndex={activeIndex} activeShape={function (shapeProps) { return renderActiveShape({ value: value, fillColorClass: fillColorClass, chartConfig: chartConfig, shapeProps: shapeProps, hideIndicator: hideIndicator, name: name, cornerRadius: mergedCornerRadius }); }} cx={chartConfig.PIE_CX} cy={chartConfig.PIE_CY} paddingAngle={paddingAngle} startAngle={chartConfig.PIE_START_ANGLE} endAngle={chartConfig.PIE_END_ANGLE} innerRadius={chartConfig.PIE_INNER_R} outerRadius={chartConfig.PIE_OUTER_R} animationBegin={chartConfig.DEFAULT_ANIMATION_BEGIN} animationDuration={chartConfig.ANIMATION_DURATION} cornerRadius={mergedCornerRadius}>
          {data.map(function (entry) {
            if (entry.name.includes('rest')) {
                return <Cell key={entry.name} className="u-els-fill-n2 u-els-stroke-n2"/>;
            }
            return <Cell key={entry.name} className={fillColorClass}/>;
        })}
          {centerText && <Label className="u-els-font-size-h2" value={centerText} position="center"/>}
        </Pie>
        {name && <use xlinkHref={"#custom-active-shape-".concat(name)}/>}
      </PieChart>
    </ResponsiveContainer>);
};
export default ReportPieChart;
